module.exports = __webpack_public_path__ + "static/media/editZoomLink.1ae4e36f.svg";